<template>
<div>
  <b-card header="Operadores">
    <Grid name="filterGridProducts" ref="filterGridProducts" v-bind:url="url" v-bind:columns="columns" :pageable='true'  :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
export default {
  name: 'Products',
  components: {
    Grid
  },
  data() {
    return {
      preload: [{
        field: 'activity_type_id',
        api: 'activities/lst'
      }, {
        field: 'visibility_id',
        api: 'visibilities/lst'
      }, {
        field: 'operator_group_id',
        api: 'operatorgroups/lst'
      }, {
        field: 'district_id',
        api: 'districts/lst'
      }, {
        field: 'county_id',
        api: 'counties/lst'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'updated_at': {
          type: 'date'
        },
        'visibility_id': {
          type: 'number'
        },
        'activity_type_id': {
          type: 'number'
        },
        'operator_group_id': {
          type: 'number'
        },
        'county_id': {
          type: 'number'
        },
        'district_id': {
          type: 'number'
        }
      },
      url: 'tables/clients',
      columns: [{
        width: '160px',
        field: 'codle',
        title: 'Código LE'
      }, {
        width: '120px',
        field: 'nif',
        title: 'NIF'
      }, {
        width: '160px',
        field: 'name',
        title: 'Nome'
      }, {
        field: 'commercial_designation',
        title: 'Designação Comercial',
        width: '200px'
      }, {
        field: 'activity_type_id',
        title: 'Tp Actividade',
        width: '200px',
        values: []
      }, {
        field: 'operator_group_id',
        title: 'Grupo Operadores',
        width: '200px',
        values: []
      }, {
        field: 'visibility_id',
        title: 'Visibilidade',
        width: '200px',
        values: []
      }, {
        field: 'county_id',
        title: 'Concelho',
        width: '200px',
        values: []
      }, {
        field: 'district_id',
        title: 'Distrito',
        width: '200px',
        values: []
      }, {
        field: 'updated_at',
        title: 'Atualizado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }, {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// clients.vue?d43b71d0